import React, { useState, useEffect, useCallback, useMemo } from "react";
import product1 from "../../../../Images/theme-53-p1.png";
import { environmentVariables } from "../../../../config/env.config";
import Drawer from "react-bottom-drawer";
import CustomerDetails from "./CustomerDetails";
import axios from "axios";
import CartSummary from "./CartSummary";
import { toast } from "react-toastify";
import { getCurrencyData, getShortDescription } from "../../../../utils/utility";
import { useTranslation } from "react-i18next";
import QRCodePopup from "../../../../Components/QRCodePopup";
import SuccessPopup from "../../../../Components/SuccessPopup";
import { createOrderForInfluencer } from "../../../Components/CustomPaymentPopup/LocalPayment";
import Pusher from "pusher-js";

export const Products = ({ data, active, toggleProduct, currencySymbol, updatedState,setUpdatedState,colordata }) => {
  const items = Array.from({ length: 10 }, (_, index) => index + 1);
  const [closing, setClosing] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isCartSummaryVisible, setIsCartSummaryVisible] = useState(false);
  const [selectedProData, setSelectedProData] = useState(null);
  const [selectedUserData, setSelectedUserData] = useState(null);
  const [cartSummaryData, setCartSummaryData] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showQRCodePopup,setShowQRCodePopup]=useState(false);
  const [qrCodeImage, setQRCodeImage] = useState(null);
  const [loadingQRCode, setLoadingQRCode] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false); // State to control SuccessPopup visibility
  const [paymentDetails, setPaymentDetails] = useState({}); // State to store payment details
  const [productDetails, setProductDetails] = useState("");
  const [orderId,setOrderId]=useState('');
  const currencyForCustomPay =  getCurrencyData(data?.shipCountry)
  
  let customer_data = localStorage.getItem("Customer");
  let cusData = (!!customer_data)?JSON.parse(customer_data):"";
  const { t } = useTranslation();
  // console.log("data====>>>", data);
  
  
  const openDrawer = useCallback(() => setIsVisible(true), []);
  const closeDrawer = useCallback(() => setIsVisible(false), []);
  const openCartSummaryDrawer = useCallback(
    () => setIsCartSummaryVisible(true),
    []
  );
  const closeCartSummaryDrawer = useCallback(
    () => setIsCartSummaryVisible(false),
    []
  );

  const fronturl = environmentVariables?.frntUrl;
  const httpProtocol = environmentVariables?.httpProtocol;

  const handleAddToOrder = (menuItem) => {
    // Check if item is already in cart
    console.log("menuItem===>>>", menuItem);
    setCartItems((prevCartItems) => {
      const isAdded = prevCartItems.some((item) => item.id === menuItem.id);
      
      if (isAdded) {
        // If already added, remove from cart
        return prevCartItems.filter((item) => item.id !== menuItem.id);
      } else {
        if(menuItem?.infproduts?.product_price?.toLowerCase() != "not available"){
          
          // Add item to cart with selected properties
          const newItem = {
            id: menuItem.id,
            product_id: menuItem?.product_id,
            name: menuItem.infproduts.product_name,
            price: menuItem.base_price,
            listing_price: menuItem.listing_price,
            image: `${environmentVariables.s3UrlBackendUrl}${menuItem.infproduts.image}`,
            quantity: 1,
            currencySymbol: currencySymbol,
          };
          return [...prevCartItems, newItem];
        }else{
          return prevCartItems;
        }        
      }
    });
  };

  const removeItem = (index) => {
    setCartItems((prevItems) => prevItems.filter((item, i) => i !== index));
  };

  const updateItemQuantity = useCallback((index, quantity) => {
    setCartItems((prevItems) =>
      prevItems.map((item, i) =>
        i === index ? { ...item, quantity: quantity } : item
      )
    );
  }, []);

  const transformedProducts = useMemo(() => {    
    return cartItems.map((product) => ({
      influencer_product_id: product.id,
      product_id: product.product_id,
      quantity: product.quantity,
      name: product?.name,
      single_price: product?.listing_price,
      base_price: product?.price,
      price_x_qty:
        product?.listing_price && product.quantity
          ? parseFloat(product.listing_price) * Number(product.quantity)
          : 0,
    }));
  }, [cartItems]);

  const createOrder = async () => {
    setLoader(true);

    // set current business slug in localstorage
    const slugb = data?.slug;
    const slug_subdomain = data?.slug_subdomain;
    let businessUrl =
      slug_subdomain != null
        ? httpProtocol + slug_subdomain
        : slugb != null
        ? fronturl + slugb
        : "/";
    
    localStorage.setItem("businessUrl", businessUrl);
    localStorage.setItem("orderCurrencySymbol", currencySymbol);
    // Calculate subtotal based on product price and quantity from the cart
    const couponId = cartSummaryData?.couponID || 0;
    const subTotal = cartSummaryData?.totalAmount || 0;
    const deliveryCharge = 0; // Set this based on your delivery charge logic
    const discount = cartSummaryData?.discountAmount || 0; // Set this based on your discount logic
    const total = cartSummaryData?.isAppliedCoupon ? cartSummaryData?.totalAmountAfterDiscount:cartSummaryData?.totalAmount;
    let productsInfo = data?.influencerProducts;
    let singleProData = productsInfo.length>0?productsInfo[0]:"";
    
    // Set form data dynamically using productData and userDetails
    const dataTobeSend = {
      products: transformedProducts,
      coupon_id: couponId,
      business_id: data?.id,
      product_business_id: !!singleProData?singleProData?.product_business_id:null,
      influencer_id: data?.influencer_id,
      sub_total: subTotal?.toFixed(2),
      delivery_charge: deliveryCharge,
      discount: discount,
      total: total?.toFixed(2),
      payment_method: "PAYPOINT",
      customer_id:cusData?.id,
      currency:currencySymbol,
      user_name: selectedUserData?.name,
      user_email: selectedUserData?.email,
      user_mobile: selectedUserData?.phone,
      user_country_code: selectedUserData?.countryCode,
      user_address: selectedUserData?.address,
    };
    setTotalAmount(total?.toFixed(2));
    console.log("dataTobeSend", dataTobeSend);
    
    const responsedata = await createOrderForInfluencer(dataTobeSend, data);
    console.log("responsedata", responsedata);    
    try {
      setLoader(false);
      setQRCodeImage(responsedata?.data);
      setOrderId(responsedata?.orderId)
      setShowQRCodePopup(true)
    } catch (error) {
      console.log(error?.response?.data?.message || error?.message);
    }
  };
  useEffect(() => {
    // Initialize Pusher
    const pusher = new Pusher(environmentVariables?.pusherKey, {
          cluster: "ap2",
        });

        const channelName = `paypoint-updates-${orderId}`; // Replace with the actual order ID
        const channel = pusher.subscribe(channelName);
    
    // Listen for payment success event
    channel.bind("payment-status-update", (data) => {
      console.log("Payment Success Event Received:", data);

      // Close QR Code Popup
      setShowQRCodePopup(false);

      // Show Payment Successful Popup
      // Set payment details for the success popup
      setPaymentDetails({
        receiver: data?.title,
        paymentMethod: "PayPoint",
        amountPaid: data.amount,
        transactionId: data.transaction_id,
        paymentTime: data.timestamp, // Assuming `payment_time` is sent in the webhook
        currency: currencyForCustomPay,
      });

      // Show the SuccessPopup
      setShowSuccessPopup(true);
    });

    // Cleanup on component unmount
    return () => {
      pusher.unsubscribe("payment-status-update");
    };
  }, [currencyForCustomPay, orderId]);

  const handleProceedDPO = async () => {
    try {
      setLoader(true);
      const transformedProducts = cartItems.map((product) => ({
        influencer_product_id: product.id,
        product_id: product.product_id,
        quantity: product.quantity,
        name:product?.name,
        single_price:product?.listing_price,
        base_price:product?.price,
        price_x_qty: (!!product?.listing_price)?parseFloat(product?.listing_price) * Number(product.quantity):0
      }));

      // set current business slug in localstorage
      const slugb = data?.slug;
      const slug_subdomain = data?.slug_subdomain;
      let businessUrl =
        slug_subdomain != null
          ? httpProtocol + slug_subdomain
          : slugb != null
          ? fronturl + slugb
          : "/";
      localStorage.setItem("businessUrl", businessUrl);
      localStorage.setItem("orderCurrencySymbol", currencySymbol);

      // Calculate subtotal based on product price and quantity from the cart
      const couponId = cartSummaryData?.couponID || 0;
      const subTotal = cartSummaryData?.totalAmount || 0;
      const deliveryCharge = 0; // Set this based on your delivery charge logic
      const discount = cartSummaryData?.discountAmount || 0; // Set this based on your discount logic
      const total = cartSummaryData?.isAppliedCoupon ? cartSummaryData?.totalAmountAfterDiscount:cartSummaryData?.totalAmount;
      let productsInfo = data?.influencerProducts;
      let singleProData = productsInfo.length>0?productsInfo[0]:"";

      const dataToBeSave = {
        products: transformedProducts,
        coupon_id: couponId,
        business_id: data?.id,
        product_business_id: !!singleProData?singleProData?.product_business_id:null,
        influencer_id: data?.influencer_id,
        sub_total: subTotal,
        delivery_charge: deliveryCharge,
        discount: discount,
        total: total,
        currencyName: "AED",
        currency:currencySymbol,
        payment_method: "TOTALPAY",
        customer_id:cusData?.id,
        user_name: selectedUserData?.name,
        user_email: selectedUserData?.email,
        user_mobile: selectedUserData?.phone,
        user_country_code: selectedUserData?.countryCode,
        user_address: selectedUserData?.address,
        cURL:businessUrl
      };
      
      const response = await fetch(
        `${environmentVariables?.apiUrl}api/v1/payment/getTransTokenForProduct`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(
            dataToBeSave
          ),
        }
      );

      const dataResponse = await response.json();
      console.log("dataResponse", dataResponse);
      
      // Handle the response from the backend
      if (response.ok) {
        // Payment initiated successfully
        if (
          dataResponse?.redirectUrl
        ) {
          window.location.href = dataResponse?.redirectUrl;
          setLoader(false);
        } else {
          console.error("Missing data for redirect");
          setLoader(false);
        }
      } else {
        // Payment initiation failed
        console.error("Error initiating payment:", dataResponse.message);
        setLoader(false);

        // setIsPaymentBtnClicked(false);
      }
    } catch (error) {
      console.error("Error initiating payment:", error);
      setLoader(false);

      // setIsPaymentBtnClicked(false);
    }

    // setIsPaymentBtnClicked(false);
  };

  // const link = `${environmentVariables.apiUrl}uploads/gallery/${item.image}`;
  const handleClose = () => {
    setClosing(true);
    setTimeout(() => {
      toggleProduct();
      setClosing(false);
    }, 600);
  };
  let customerData = localStorage.getItem("Customer");
  useEffect(() => {
    if (!!selectedUserData) {
      callPG();
    }
  }, [selectedUserData]);

  const callPG = () => {
    if (!!data?.shipCountry && data?.shipCountry == "IN") {
      createOrder();
    } else {
      handleProceedDPO();
    }
  };

  const handleFormSubmit = (formData) => {
    setLoader(true);
    setSelectedUserData(formData);
  };

  const handleBuyNow = (selectedProductData) => {
    openDrawer();
    setSelectedProData(selectedProductData);
  };
  const handleSummaryData = (cartSummaryDetails) =>{   
    setCartSummaryData(cartSummaryDetails);
  }

  const handleCloseQRCodePopup=()=>{
    setShowQRCodePopup(false);
    setQRCodeImage(null);
    setLoadingQRCode(false);
  }
  const handleCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
    window.location.reload(); // Reload the page to reflect changes
  };

  return (
    <section
      style={{ bottom: closing ? "-100%" : active ? "50px" : "-100%" }}
      className={`${active ? "product-popup" : ""}`}
    >
      <div className="product-popup-inner">
        <article className="products sec" style={{background: data?.dynamicBackgroundColor}}>
          <h3 className="sectitle" style={{color:data?.dynamicTextHeadingColor}}>{t("Products")}</h3>
          <p className="cross">
            {active && <i onClick={handleClose} className="fa-solid fa-x" style={{color:data?.dynamicTextHeadingColor}}></i>}
          </p>
          <div className="product-inner">
            {!!data &&
              data?.influencerProducts?.length > 0 &&
              data?.influencerProducts?.map((item) => {
                const infProduct = item.infproduts;
                const link = `${environmentVariables.s3UrlBackendUrl}${infProduct?.image}`;
                const isAdded = cartItems.some(
                  (cartItem) => cartItem.id === item.id
                );

                return (
                  <div className="item" key={item}>
                    <div className="image">
                      <img loading="lazy" src={link} style={{background:data?.dynamicMainBackgroundColor}} alt={infProduct.product_name} />
                    </div>
                    <h6 style={{color:data?.dynamicTextDescriptionColor}}>{infProduct.product_name}</h6>
                    {/* <p>{`${currencySymbol}${infProduct?.product_price !== "Not available" ? infProduct.product_price : "N/A"}/-`}</p> */}
                    {!!item?.listing_price &&
                    item?.listing_price !== "Not available" ? (
                      <p style={{color:data?.dynamicTextDescriptionColor}}>
                      {/* {`${currencySymbol}${parseFloat(item?.listing_price).toFixed(2)}`} */}
                    {currencySymbol === "₹" 
                      ? `${currencySymbol}${parseFloat(item?.listing_price).toFixed(2)}`
                      : `${parseFloat(item?.listing_price).toFixed(2)} AED`}

                      </p>
                    ) : (
                      <>
                        <p style={{color:data?.dynamicTextDescriptionColor}}> {t("NA")}</p>
                      </>
                    )}

                    <button onClick={() => handleAddToOrder(item)}>
                      {isAdded ? (
                        <div className="addeditem">{t("Added")}</div>
                      ) : (
                        <div className="addtocartitem" style={{color:data?.dynamicCtaTextColor, background:data?.dynamicCtaColor}}>{t("Add_to_cart")}</div>
                      )}
                    </button>
                  </div>
                );
              })}
          </div>
          {cartItems.length > 0 && (
            <div className="continue-popup" onClick={openCartSummaryDrawer}>
              <button
                className="continue-popupbutton"
                style={{ color: "white" }}
              >
                <span>{`${cartItems.length} ${t("Item_selected")}`}</span>
                {t("Continue")}
              </button>
            </div>
          )}
        </article>
        <Drawer
          duration={150}
          hideScrollbars={true}
          onClose={closeDrawer}
          isVisible={isVisible}
          className="drawer"
        >
          <CustomerDetails
            closeDrawer={closeDrawer}
            onSubmit={handleFormSubmit}
            loader={loader}
            customerData={customerData}
            colordata={colordata}
          />
        </Drawer>
        <Drawer
          duration={150}
          hideScrollbars={false}
          onClose={closeCartSummaryDrawer}
          isVisible={isCartSummaryVisible}
          className="cartdrawer"
        >
          <CartSummary
            cartItems={cartItems}
            closeDrawer={closeCartSummaryDrawer}
            removeItem={removeItem}
            openDrawer={openDrawer}
            closeCartSummaryDrawer={closeCartSummaryDrawer}
            updatedState={updatedState}
            setUpdatedState={setUpdatedState}
            handleSummaryData={handleSummaryData}
            inf_id={data?.influencer_id}
            updateItemQuantity={updateItemQuantity}
          />
        </Drawer>
        <QRCodePopup 
          show={showQRCodePopup}
          onClose={handleCloseQRCodePopup}
          loading={loadingQRCode}
          qrCodeImage={qrCodeImage}
          productDetails={productDetails}
          totalAmount={totalAmount}
          />
        <SuccessPopup
          show={showSuccessPopup}
          onClose={handleCloseSuccessPopup}
          receiver={paymentDetails.receiver}
          paymentMethod={paymentDetails.paymentMethod}
          amountPaid={paymentDetails.amountPaid}
          transactionId={paymentDetails.transactionId}
          paymentTime={paymentDetails.paymentTime} // Pass payment time to the popup
          currency={paymentDetails.currency}
          title="Payment Successful"
        />
      </div>
    </section>
  );
};
